export const dayMonth = "dd MMM";
export const dateDayMonth = "iii dd MMM";
export const dayMonthYear = "iii dd MMM yyyy";
export const dateFullMonthYear = "dd MMMM yyyy";
export const dateFullMonthYearTime = "dd MMMM yyyy, k:mm";
export const dateMonthYearTimeSeconds = "dd MMMM yyyy, k:mm:ss";
export const monthYear = "MMMM yyyy";
export const monthDateDayTime = "MMM dd iii k:mm";
